var Popup = window.Popup = (function() {
    function Show(popupSelector: any) {
        let popup = null;
        const scrollPage = $(document).scrollTop();

        $(".m-mobile body").css({ position: 'fixed', top: -scrollPage + 'px', overflow: 'hidden' });

        if (popupSelector) {
            popup = $(popupSelector)[0];
        }
        else if (!popupSelector && this.Selector) {
            var possiblePopups = $('.popup', this.Selector);
            if (possiblePopups.length > 0) {
                popup = possiblePopups[0];
            }
        }


        if (!popup) return;
        const blockUi: any = UiBlock.getUiBlockDescriptor(popup);

        if (UiBlock.needBlock(blockUi)) {

            blockUi.message = popup.outerHTML;
            $(popup).remove();

            var previousOnBlock = blockUi.onBlock;
            blockUi.onBlock = function () {
                Controls.parse(this);
                if (previousOnBlock) previousOnBlock.call(this, arguments);
            }
            UiBlock.block(blockUi);
        }
        else {
            $(popup).show();
        }

        initHistoryBetCalcPopupPopover();

        document.dispatchEvent(
            new CustomEvent('mtmCustomEvent', {
                detail: {
                    id: 'popup-show',
                    popup,
                },
            })
        );
    }

    function isInPopup(element: any) {
        return $(element).parents('.popup').length > 0;
    }

    function getPopupSelector(element: any) {
        var parentPopup = $(element).parents('.popup')
        var popupCssClasses = parentPopup.attr('class').split(/\s+/);
        var popupSelector = parentPopup.prop('tagName');
        if (popupCssClasses.length > 0) {
            popupSelector += '.' + popupCssClasses.join('.');
        }

        return popupSelector;
    }

    function Close(element: any) {
        const popup = findPopup(element);
        const blockUi: any = UiBlock.getUiBlockDescriptor(popup);
        const scrollPage = $(".m-mobile body").css('top');

        $(".m-mobile body").css({ position: '', top: '', overflow: '' });
        window.scrollTo(0, parseInt(scrollPage || '0') * -1);

        if (UiBlock.needBlock(blockUi)) {
            UiBlock.unBlock(blockUi);
            $(popup).remove();
        }
        else {
            $(popup).hide();
        }
        document.dispatchEvent(
            new CustomEvent('mtmCustomEvent', {
                detail: {
                    id: 'popup-close',
                    popup,
                },
            })
        );
    }

    function CloseWithCheckFlag(element: any, flagSelector: any, messageId: number) {
        const popup = findPopup(element);
        const flag = ($(popup).find(flagSelector)[0]) as HTMLInputElement;
        const state = flag.checked;

        Ajax.postJson("/ajax/message/modal/close", {
            data: {
                messageId: messageId,
                stateModal: state
            },
            error: function () {
            }
        });

        Close(element);
    }

    function findPopup(element: any) {
        return $(element).parents('.popup')[0];
    }

    function SwitchLink(from: any, to: any, imgUrl: any) {
        var popup = findPopup(from);

        $(from).hide();
        $(to, popup).show();
        if (!!imgUrl) {
            $(to).append('<img src="' + imgUrl + '" style="opacity: 0; width: 1px; height: 1px" alt="" />');
        }
    }

    function initHistoryBetCalcPopupPopover() {
        const isInitParam = !!(+sessionStorage.getItem('initHistoryBetCalcPopupPopover'));

        if (!isInitParam) {
            return;
        }

        document.dispatchEvent(new CustomEvent('betCalcPopupPopover:show'));
    }

    return {
        Show,
        isInPopup,
        getPopupSelector,
        Close,
        CloseWithCheckFlag,
        SwitchLink
    }
}());